/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanySearchResultResource } from './';
import {
    CompanySearchResultResourceFromJSON,
    CompanySearchResultResourceFromJSONTyped,
    CompanySearchResultResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ScimAttributeMappingConfigurationResource
 */
export interface ScimAttributeMappingConfigurationResource {
    /**
     * 
     * @type {string}
     * @memberof ScimAttributeMappingConfigurationResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ScimAttributeMappingConfigurationResource
     */
    value: string;
    /**
     * 
     * @type {CompanySearchResultResource}
     * @memberof ScimAttributeMappingConfigurationResource
     */
    companyTarget?: CompanySearchResultResource;
}

/**
 * Check if a given object implements the ScimAttributeMappingConfigurationResource interface.
 */
export function instanceOfScimAttributeMappingConfigurationResource(value: object): value is ScimAttributeMappingConfigurationResource {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ScimAttributeMappingConfigurationResourceFromJSON(json: any): ScimAttributeMappingConfigurationResource {
    return ScimAttributeMappingConfigurationResourceFromJSONTyped(json, false);
}

export function ScimAttributeMappingConfigurationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScimAttributeMappingConfigurationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'companyTarget': json['companyTarget'] == null ? undefined : CompanySearchResultResourceFromJSON(json['companyTarget']),
    };
}

export function ScimAttributeMappingConfigurationResourceToJSON(value?: ScimAttributeMappingConfigurationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
        'companyTarget': CompanySearchResultResourceToJSON(value['companyTarget']),
    };
}

